export default __webpack_public_path__ + "fr/static/media/picto-close.2d57389a.svg";